import { render } from "./Spinner.ce.vue?vue&type=template&id=10842c99"
import script from "./Spinner.ce.vue?vue&type=script&lang=js"
export * from "./Spinner.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__